import { render, staticRenderFns } from "./ViewBoardPost.vue?vue&type=template&id=30337794&scoped=true"
import script from "./ViewBoardPost.vue?vue&type=script&lang=js"
export * from "./ViewBoardPost.vue?vue&type=script&lang=js"
import style0 from "./ViewBoardPost.vue?vue&type=style&index=0&id=30337794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30337794",
  null
  
)

export default component.exports